import Registration from "../../../jsx/pages/Registration";

const LoginWrapper = function (props) {
  return <Registration />;
};

export default constore(LoginWrapper);
